<template>
	<div class="mainContainer pa-0" v-show="display">
		<div class="content pl-6">
			<div class="title">복잡한 하자관리</div>
			<div class="title">AI채커가</div>
			<div class="title">도와드려요!</div>
			<v-btn
				rounded
				color="#00b5ad"
				class="manual-button mt-8"
				@click="HANDLE_OPEN_DIALOG"
			>
				매뉴얼 신청하기
				<v-icon right>mdi-plus</v-icon>
			</v-btn>
		</div>
		<div class="aiImage" >
			<div ref="container"></div>
		</div>
		<div class="ai-close mt-2" @click="display = false">
			<v-icon>mdi-close</v-icon>
		</div>
	</div>
</template>

<script>
import lottie from 'lottie-web';
import aiProcessor from '@/assets/ai/Ai_Processor.json';

export default {
	data(){
		return {
			display: true
		}
	},
	mounted() {
		lottie.loadAnimation({
			container: this.$refs.container,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			animationData: aiProcessor
		});
		const isMobile = /Mobi|Android/i.test(navigator.userAgent);
		if(isMobile)
		{
			this.display = false;
		}
	},
	methods: {
		HANDLE_OPEN_DIALOG()
		{
			this.$store.commit('common/setDialogAi', true);
		}
	}
}
</script>

<style scoped>
.mainContainer {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px;
	box-sizing: border-box;
	gap: 12px;

	width: 380px;
	height: 190px;
	border-radius: 12px;
	background-color: #fff;
}

.content {
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 4px;
	flex: 1 1 auto;
	min-width: 0;
}

.title {
	font-family: 'Pretendard', sans-serif !important;
	font-size: 18px;
	font-weight: bold;
	line-height: 1.1;
	color: #000;
}

.manual-button {
	font-family: 'Pretendard', sans-serif;
	font-size: 14px;
	font-weight: 500;
	margin-top: 8px;
	align-self: flex-start;
	color: #000;
}

.aiImage {
	flex: 0 0 180px;
	height: 180px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.aiImage > div {
	width: 100%;
	height: 100%;
	margin-left: -100px;
}

.ai-close {
	position: absolute;
	top: 10px;
	right: 10px;
	cursor: pointer;
}
.ai-close > .v-icon  {
	color: #000;
	font-size: 30px !important;
}
</style>

